import { useEffect, useState } from 'react'
import useSession from 'tennders-auth/hooks/useSession'
import { PAYMENT_TERM_SPOT } from 'tennders-common/types/enums'
import useFetchOptions from 'tennders-common/hooks/useFetchOptions'
import { PaymentTermTypes } from 'tennders-company/common/types/PaymentTermTypes'

export const withPaymentTermForm = (WrappedComponent) => ({ initialForm, ...rest }) => {
  const { user } = useSession()
  const { options } = useFetchOptions()
  const [standardSelected, setStandardSelected] = useState(false)
  const [paymentTermForm, setPaymentTermForm] = useState(initialForm || {
    type: null,
    cmrType: null,
    dType: null,
    priceType: 1,
    days: 30
  })

  const paymentTerms = user?.company?.paymentTerms
    ? [...user?.company?.paymentTerms?.filter((x) => x.type.code === PaymentTermTypes.STANDARD_CARRIER)
      .map((y) => ({ label: y.type.code[0] + y.type.code.slice(1).toLocaleLowerCase(), value: y.type.value })), { label: PAYMENT_TERM_SPOT, value: -1 }]
    : []

  const onChange = (k, v) => {
    setPaymentTermForm({ ...paymentTermForm, [k]: v })
    if (rest?.seterrors) {
      rest.seterrors(prevState => ({ ...prevState, [k]: false }))
    }
  }

  const inputProps = {
    form: paymentTermForm,
    onChange,
    errors: rest.errors
  }

  const disabled = (
    /* !paymentTermForm?.type
    || !paymentTermForm.days
    || Number.isNaN(parseInt(paymentTermForm.days, 10))
    || parseInt(paymentTermForm.days, 10) <= 0
    || !paymentTermForm?.dType
    || !paymentTermForm.priceType
    || !paymentTermForm.cmrType
    || */ (!paymentTermForm.marketPrice || Number(paymentTermForm?.marketPrice) <= 0)
  )

  useEffect(() => {
    if (parseInt(paymentTermForm.type, 10) !== -1 && paymentTermForm.type !== PAYMENT_TERM_SPOT) {
      setStandardSelected(true)
      if (user?.company?.paymentTerms) {
        user?.company?.paymentTerms?.forEach((term) => {
          if (`${term.type.value}` === `${paymentTermForm?.type}`) {
            setPaymentTermForm({
              ...paymentTermForm,
              cmrType: term.cmrType.value,
              dType: term.dateType,
              days: term.days
            })
          }
        })
      }
    } else {
      setStandardSelected(false)
    }
  }, [paymentTermForm?.type])

  return (
    <WrappedComponent
      paymentTerms={paymentTerms}
      standardSelected={standardSelected}
      paymentTermProps={inputProps}
      setPaymentTermForm={setPaymentTermForm}
      paymentTermForm={paymentTermForm}
      disabled={disabled}
      options={options}
      {...rest}
    />
  )
}
